import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQ = ({ faqs = [] }) => {
  const [open, setOpen] = useState(null);

  return (
    <section id="faq" data-testid="faq-section" className="py-28 md:py-36 bg-[#080808] border-y border-white/5">
      <div className="max-w-[1000px] mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="label-caps text-[color:var(--gold)] mb-6">Questions Fréquentes</p>
          <h2 className="font-serif text-4xl md:text-5xl text-white">Vos <em className="italic text-[color:var(--gold-soft)]">interrogations</em>, nos réponses</h2>
        </div>

        <div>
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.id} className="border-b border-white/10">
                <button
                  data-testid={`faq-item-${i}`}
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-6 py-7 text-left group"
                >
                  <span className="font-serif text-lg md:text-xl text-white group-hover:text-[color:var(--gold)] transition-colors">
                    {f.question}
                  </span>
                  {isOpen ? <Minus size={18} className="text-[color:var(--gold)]" /> : <Plus size={18} className="text-white/50 group-hover:text-[color:var(--gold)]" />}
                </button>
                {isOpen && (
                  <div data-testid={`faq-answer-${i}`} className="pb-8 pr-10 text-white/60 font-light leading-relaxed">
                    {f.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
